// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lugrasimo&family=Lumanosimo&family=Merienda:wght@300..900&family=Nothing+You+Could+Do&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sorts+Mill+Goudy:ital@0;1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Lumanosimo';
    background-color:antiquewhite;
    display: flex;
    justify-content: center;
    gap: 50px; 
    padding: 50px;
}
#ship-harbor {
  display: flex;
  gap: 10px;
}
#fleet {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.active {
  background-color: #333;
  color: #eee;
}
#human-board, #computer-board {
    display: grid;
    grid-template-columns: repeat(10, 40px);
    grid-template-rows: repeat(10, 40px);
    border: 2px solid black;
}
.grid-square {
    width: 40px;
    height: 40px;
    border: 1px solid #ccc; 
    background-color: #f0f8ff; 
    color: #57636d;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8px;
}
.ship {
    background-color: #4682b4; 
    border: 1px solid #2b506e;
    color: #ccc;
}
.miss {
    background-color: #6ac187; 
    border: 1px solid #1f8808;
    color: #f0efef;
    pointer-events: none;
}
.hit {
    background-color: #bf6873; 
    border: 1px solid #c30b0b;
    color: #ccc;
    pointer-events: none;
}
#winnerDialog {
  padding: 1em;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border: none;
  border-radius: 10px;
  height: 150px;
  width: 310px;
  background-color: #333;
  color: #eee;
}
#winnerForm {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
#winnerForm h2 {
  font-size: 1.4rem;
  text-align: center;
}

#playagainButton {
  width: 60%;
  padding: 8px 10px;
  border-radius: 8px;
  font-family: 'Lumanosimo';
  cursor: pointer;
  border: none;
}
#playagainButton:hover {
    background-color: #5a9cd0;
    color: #eee;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAGA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;IACI,aAAa;IACb,uCAAuC;IACvC,oCAAoC;IACpC,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,oBAAoB;AACxB;AACA;EACE,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;AACA;IACI,yBAAyB;IACzB,WAAW;AACf","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lugrasimo&family=Lumanosimo&family=Merienda:wght@300..900&family=Nothing+You+Could+Do&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sorts+Mill+Goudy:ital@0;1&display=swap\");\n\n\nbody {\n    font-family: 'Lumanosimo';\n    background-color:antiquewhite;\n    display: flex;\n    justify-content: center;\n    gap: 50px; \n    padding: 50px;\n}\n#ship-harbor {\n  display: flex;\n  gap: 10px;\n}\n#fleet {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n.active {\n  background-color: #333;\n  color: #eee;\n}\n#human-board, #computer-board {\n    display: grid;\n    grid-template-columns: repeat(10, 40px);\n    grid-template-rows: repeat(10, 40px);\n    border: 2px solid black;\n}\n.grid-square {\n    width: 40px;\n    height: 40px;\n    border: 1px solid #ccc; \n    background-color: #f0f8ff; \n    color: #57636d;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 8px;\n}\n.ship {\n    background-color: #4682b4; \n    border: 1px solid #2b506e;\n    color: #ccc;\n}\n.miss {\n    background-color: #6ac187; \n    border: 1px solid #1f8808;\n    color: #f0efef;\n    pointer-events: none;\n}\n.hit {\n    background-color: #bf6873; \n    border: 1px solid #c30b0b;\n    color: #ccc;\n    pointer-events: none;\n}\n#winnerDialog {\n  padding: 1em;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  border: none;\n  border-radius: 10px;\n  height: 150px;\n  width: 310px;\n  background-color: #333;\n  color: #eee;\n}\n#winnerForm {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n#winnerForm h2 {\n  font-size: 1.4rem;\n  text-align: center;\n}\n\n#playagainButton {\n  width: 60%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  font-family: 'Lumanosimo';\n  cursor: pointer;\n  border: none;\n}\n#playagainButton:hover {\n    background-color: #5a9cd0;\n    color: #eee;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
